import * as React from "react";
import {cx}       from "emotion";

import "./details-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {formatMoney1}   from "@Common/ui-components/language/format-money";
import {sum}            from "@Common/utils/collections";

import {COMPANY_LEVEL} from "../../../../../common/logic/user-level";
import {InlineModal}   from "../common/inline-modal/inline-modal";

import {VoucherModal} from "./voucher-modal/voucher-modal";

export const DetailsModal = ({vouchers, next: rootNext}) => cs(
    consumeContext("session"),
    ["modal", (_, next) => InlineModal({
        rootNext,
        next,
    })],
    ["voucherModal", (_, next) => VoucherModal({vouchers, next})],
    consumeContext("userLevels"),
    ({session, modal: {params: vouchers}, userLevels, voucherModal}) => (
        <div className="details-modal-85f">
            <div className="header">
                <div className="name" xd-qa-type="text" xd-qa-name={vouchers[0].agentFullName ?? "--"}>
                    {vouchers[0].agentFullName ?? "--"}
                </div>
                {userLevels.userLevel === COMPANY_LEVEL && (
                    <div className="title" xd-qa-type="text" xd-qa-name={vouchers[0].branchName}>
                        {vouchers[0].branchName}
                    </div>
                )}

            </div>

            <div className="table">
                <div className="header">
                    <div className="main">
                        <div className="label" xd-qa-type="label" xd-qa-name="PROGRAM">
                            PROGRAM
                        </div>
                        <div className="value" xd-qa-type="label" xd-qa-name="AMOUNT">
                            AMOUNT
                        </div>
                    </div>
                    {session?.data?.branch?.enableVouchers === 1 && <div className="action">

                    </div>}
                </div>
                <div className="body">
                    <div className="copay-list">
                        {vouchers.map((voucher, i) => cs(
                            keyed(i),
                            () => <>
                            
                                {i !== 0 && (
                                    <div className="separator"/>
                                )}
                                <div className="line">
                                    <div className="main">
                                        <div className={cx("label", {"expired": isVoucherExpired(voucher)})} xd-qa-type="text" xd-qa-name={voucher.name || voucher.idProgram}>
                                            {voucher.name || voucher.idProgram}
                                        </div>
                                        <div className={cx("value", {"expired": isVoucherExpired(voucher)})} xd-qa-type="text" xd-qa-name={(voucher.name || voucher.idProgram) + ' Amount'}>
                                            {formatMoney1(+voucher.total)}
                                        </div>
                                    </div>
                                    {userLevels.userLevel === COMPANY_LEVEL ? (
                                         EditVoucherLink({voucherModal, voucher})
                                    ) : (
                                        session?.data?.branch?.enableVouchers === 1 && EditVoucherLink({voucherModal, voucher})
                                    )}
                                </div>
                            </>
                        ))}
                    </div>
                    <div className="separator"/>
                    <div className="total-line">
                        <div className="label" xd-qa-type="label" xd-qa-name='Total'>
                            Total
                        </div>
                        <div className="amount" xd-qa-type="text" xd-qa-name="Total Amount">
                            {formatMoney1(sum(vouchers, (v) => +v.total))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ),
);

const EditVoucherLink = ({voucherModal, voucher}) => (
    <div className="action" xd-qa-type="link" xd-qa-name={(voucher.name || voucher.idProgram) + ' Edit'}>
        <a
            onClick={() => voucherModal.show({voucher})}
        >
            Edit
        </a>
    </div>
)

export const isVoucherExpired = (voucher) => {
    const today = new Date();
    const expDate = voucher.dateExpiration !== null ? new Date(voucher.dateExpiration) : new Date(NaN)
    return expDate < today && !isNaN(expDate.getTime()) ? true : false
}